import { create } from "zustand";
import { persist } from "zustand/middleware";

export type CompletionAggressiveness = "conservative" | "balanced" | "aggressive";
export type CompletionLength = "short" | "medium" | "long";
export type CompletionTrigger = "pause" | "newline" | "manual";

export const AGGRESSIVENESS_DEBOUNCE: Record<CompletionAggressiveness, number> = {
  conservative: 1200,
  balanced: 600,
  aggressive: 300,
};

export const LENGTH_MAX_TOKENS: Record<CompletionLength, number> = {
  short: 128,
  medium: 256,
  long: 512,
};

interface CompletionState {
  enabled: boolean;
  aggressiveness: CompletionAggressiveness;
  maxLength: CompletionLength;
  trigger: CompletionTrigger;

  setEnabled: (enabled: boolean) => void;
  setAggressiveness: (aggressiveness: CompletionAggressiveness) => void;
  setMaxLength: (maxLength: CompletionLength) => void;
  setTrigger: (trigger: CompletionTrigger) => void;
}

export const useCompletionStore = create<CompletionState>()(
  persist(
    (set) => ({
      enabled: true,
      aggressiveness: "balanced",
      maxLength: "medium",
      trigger: "pause",

      setEnabled: (enabled) => set({ enabled }),
      setAggressiveness: (aggressiveness) => set({ aggressiveness }),
      setMaxLength: (maxLength) => set({ maxLength }),
      setTrigger: (trigger) => set({ trigger }),
    }),
    {
      name: "lever-completion",
    },
  ),
);
